import SETTING_KEYS from '../../constants/setting-keys';

type DateLike = Date | string | number;

const getVerificationDate = (value: any): DateLike | null => {
    if (!value) return null;
    if (typeof value === 'object' && value.date) return value.date;
    return null;
};

/**
 * Regional verification metadata wins when present; legacy implants keep the
 * verification metadata on the top-level info object.
 */
export const resolveLastCheckedDate = (
    info: any,
    regionalInfo?: any
): DateLike | null =>
    getVerificationDate(
        regionalInfo?.[SETTING_KEYS.verifiedByNI] ??
            regionalInfo?.verifiedByNI
    ) ??
    getVerificationDate(
        info?.[SETTING_KEYS.verifiedByNI] ?? info?.verifiedByNI
    );

